
import * as React from "react";
const ArrowRightOatIconSvg = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.45508 9.96004L7.71508 6.70004C8.10008 6.31504 8.10008 5.68504 7.71508 5.30004L4.45508 2.04004"
      stroke="#D5D1C9"
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowRightOatIconSvg;
